import { GridSaveViewForm } from './component/GridSaveViewForm';
import { WEB_COMPONENT_GRID_SAVE_VIEW_FORM } from '../../../webcomponents.constants';

export { GridSaveViewForm };
window.customElements.define(WEB_COMPONENT_GRID_SAVE_VIEW_FORM, GridSaveViewForm);
